import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import Draggable from "react-draggable";
import { translate } from "../../core/i18n";
import { redirectToNewTab } from "../../features/redirect";
import { CloseButton } from "../buttons/base/CloseButton";
import { editorUndo, insertTextAtCursor } from "../MonacoEditorHelper";
import { showQuestionModal } from "../modals/QuestionModal";
import { isResponsiveView } from "../../features/responsive";

export const CodeEntryHelperArea = (props : { chars : any[], link? : string, open? : boolean , close }) => {
  
  const startKeyboardHelp = () => {
    redirectToNewTab(props.link)
  }

  const keyboardHelpRequested = () => {
    const opts = {
      okTitle: translate("keyboard-help-ok")
    }
    showQuestionModal(translate("keyboard-help-title"), translate("keyboard-help-text"), startKeyboardHelp, () => {}, opts);
  }

  const insertChar = (char) => {
    insertTextAtCursor(char, false);
  }

  const execCmd = (cmd) => {
    if (cmd === "UNDO") {
      editorUndo();
    }
  }

  const keyContentForCmd = (cmd) => {
    if (cmd === "UNDO") {
      return <FontAwesomeIcon icon="delete-left" />;
    }
    return null;
  }

  if (!props.chars) {
    return null;
  }

  const headerText = <div className="col text-start m-1">{translate("keyboard-helper-title")}</div>
  const closeButton = (<div className="col text-end">
    <CloseButton onClick={() => { props.close() }} />
  </div>);
  const headerArea = (<div className="card-header draggable-header">
    <div className="row">
      {headerText}
      {closeButton}
    </div>
  </div>);

  const entries = props.chars?.map((key, index) => {
    if (key.char) {
      return <kbd className={`m-1 kbd-size ${key.className}`} title={key.shortcut} onClick={() => insertChar(key.char)} key={key.char+index}>{key.char}</kbd>
    } else if (key.cmd) {
      return <kbd className={`m-1 kbd-size ${key.className}`} title={key.shortcut} onClick={() => execCmd(key.cmd)} key={key.char+index}>{keyContentForCmd(key.cmd)}</kbd>
    }
    return null;
  })
  const description = <p>{ translate('keyboard-helper-description') }</p> ;
  const helpLink = <p className="m-2">{ props.link && <span className="fakeLink" onClick={keyboardHelpRequested}>{ translate('keyboard-help')}</span> }</p>;

  const dragDisabled = isResponsiveView();
  const area =
  <Draggable disabled={dragDisabled}>
    <div className="card m-1 draggableArea">
      { !props.open && headerArea }
      <div className="card-body">
        { description }
        { entries }
        { helpLink }
      </div>
    </div>
  </Draggable>
  return area;
}